// --- helpers ---
const rgba = (r, g, b, a = 1) => ({ r, g, b, a });
const clamp = (v, lo, hi) => Math.min(Math.max(v, lo), hi);
const mix = (a, b, t) => a + (b - a) * t;
const mixColor = (c1, c2, t) =>
  rgba(
    Math.round(mix(c1.r, c2.r, t)),
    Math.round(mix(c1.g, c2.g, t)),
    Math.round(mix(c1.b, c2.b, t)),
    mix(c1.a, c2.a, t)
  );
const toCss = ({ r, g, b, a }) => `rgba(${r}, ${g}, ${b}, ${a})`;

// --- anchors from your palette ---
const A = rgba(83, 192, 75, 1);  // A
const B = rgba(54, 162, 235, 1);   // B
const C = rgba(255, 205, 86, 1);   // C
const D = rgba(255, 57, 39, 1);   // D
const F = rgba(52, 52, 52, 1);   // F

/**
 * Smooth GPA -> RGBA with breaks at 2.0, 3.0, 4.0
 * [0,2): F→D→C   (two-step blend within the band)
 * [2,3): C→B
 * [3,4]: B→A
 * ≥4: A
 */
export default function getGPAColor(gpa) {
  const x = clamp(Number(gpa) || 0, 0, 4);

  if (x < 2) {
    // 0..2: F -> D -> C
    const t = x / 2;                   // 0..1
    return toCss(t < 0.5
      ? mixColor(F, D, t * 2)          // 0..1 in first half
      : mixColor(D, C, (t - 0.5) * 2)  // 0..1 in second half
    );
  } else if (x < 3) {
    // 2..3: C -> B
    return toCss(mixColor(C, B, x - 2));
  } else {
    // 3..4: B -> A (and clamp >=4 to A)
    return toCss(mixColor(B, A, x - 3));
  }
}
